import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { getDynamicName } from '../../../helpers/GetDynamicItemName/getDynamicName';
// Locale
import messages from '../../../locale/jsonMessages';

//Imgae
import tickIcon from '/public/SiteIcons/rulesIcon.svg';

import cs from '../../commonStyle.css';
import s from './Payment.css';

class HouseRules extends Component {
  static propTypes = {
    houseRules: PropTypes.array.isRequired,
    hostDisplayName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
  };

  render() {
    const { hostDisplayName, houseRules, locale, dynamicLanguageData } = this.props;

    return (
      <>
        <h4 className={cx(s.titleText, cs.paddingBottom2)}>
          3. <FormattedMessage {...messages.readText} /> {hostDisplayName}'s <FormattedMessage {...messages.carRules} />
        </h4>
        <p className={cx(cs.commonContentText, cs.paddingBottom2)}><FormattedMessage {...messages.readText} /> {hostDisplayName}'s <FormattedMessage {...messages.rulesDes} /></p>
        {
          houseRules.map((item, index) => {
            if (item.listsettings.isEnable === "1") {
              let dynamicName = getDynamicName({ value: item?.listsettings, locale, data: dynamicLanguageData });
              return (
                <h5 className={cx(s.houseRules, cs.paddingTop2, cs.commonContentText, cs.fontWeightNormal)} key={index}>
                  <img src={tickIcon} className={'commonIconSpace'} />
                  <span>{dynamicName?.itemName}</span>
                </h5>
              )
            }
          })
        }
      </>
    );
  }
}

const mapState = (state) => ({
  locale: state?.intl?.locale,
  dynamicLanguageData: state?.dynamicListSettings?.data
});

export default injectIntl(withStyles(cs, s)(connect(mapState)(HouseRules)));